import { useContext, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { selectPathname } from 'rdx/router';

import { MenuContext } from 'root/navigation/navStructureUtils';

import { parseUrlLocation } from './parseUrlLocation';

const appTitleIntlKey = 'appName';
const titleSeparator = ' - ';

// Usage of this hook must not overlap on the same document,
// it should only be active in a single rendering component
export const useTitle = (forceOverrideTitleIntlId?: string): void => {
  const intl = useIntl();
  const pathname = useSelector(selectPathname);
  const menuCategories = useContext(MenuContext)?.menu;

  useEffect(() => {
    let pageTitleIntlId: string | null = null;

    if (forceOverrideTitleIntlId) {
      pageTitleIntlId = forceOverrideTitleIntlId;
    } else {
      const { category, item } = parseUrlLocation(pathname, menuCategories);
      pageTitleIntlId = item?.titleIntlId || category?.titleIntlId || null;
    }

    document.title = [pageTitleIntlId, appTitleIntlKey]
      .filter((titleKey) => titleKey)
      .map((titleKey) => intl.formatMessage({ id: titleKey }))
      .join(titleSeparator);
  }, [pathname, menuCategories, forceOverrideTitleIntlId, intl]);
};
